import type { ReactNode } from "react";

/**
 * Ürün adını üst çubuğa çizilecek düğüme çeviriyor: SON SÖZCÜK marka renginde — «ALTEK **ERP**».
 *
 * Kendi dosyasında, çünkü iki yerden okunuyor: kabuk ve testi. Bir bileşen gövdesinde
 * tanımlanan bileşen her çizimde yeni bir TÜR olur ve React alt ağacı söker — bu oturumda bir
 * kez bunun bedeli ödendi, ve aynı tuzağa modül seviyesinde de düşülebilir.
 *
 * «ERP» ARANMIYOR, son sözcük boyanıyor. Kurulum adı değiştirebiliyor
 * (`core.brand.product_name`) ve kural o adlarda da okunaklı kalıyor: «İntraline ERP»,
 * «Örnek A.Ş. Portal». Tek sözcüklük bir adda bölünecek bir şey yok, o hâliyle çiziliyor —
 * yarısı boyanmış tek sözcük, bir tasarım değil bir kaza gibi görünürdü.
 *
 * Rengi `--brand-mark`, `warning` ailesi değil: o renk «dikkat» demek ve ürünün kendi adı bir
 * uyarı değil. Aynı turuncu yanındaki işarette de duruyor, yani çubuk tek renk okunuyor.
 */
export function brandedName(name: string): ReactNode {
  const trimmed = name.trim();
  const cut = trimmed.lastIndexOf(" ");
  if (cut <= 0) return trimmed;
  return (
    <>
      {trimmed.slice(0, cut)} <span className="text-brand-mark">{trimmed.slice(cut + 1)}</span>
    </>
  );
}
